import React from 'react';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonList,
  IonPage,
  IonToolbar
} from '@ionic/react';
import { arrowBackOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';

interface CourseSelectionPageProps {
  club: any; // Using any to match the original implementation
  onBack: () => void;
  onSelectCourse: (course: any) => void;
}

const capitalizeCityName = (name: string) => {
  if (!name) return '';
  return name.split(',')[0].trim();
};

const CourseSelectionPage: React.FC<CourseSelectionPageProps> = ({
  club,
  onBack,
  onSelectCourse
}) => {
  const { t } = useTranslation();

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={onBack}>
              <IonIcon slot="icon-only" icon={arrowBackOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent className="flex-1">
        <div className="p-4">
          <div className="text-2xl font-semibold mb-2">{t('select_course')}</div>
          <div className="font-semibold text-muted-foreground mb-4">{capitalizeCityName(club.name)}</div>

          <IonList lines='none' className="space-y-2">
            {Array.isArray(club.courses) && club.courses.length > 0 ? (
              club.courses.map((course: any) => (
                <IonItem
                  key={course.courseId || `course-${course.courseName}`}
                  detail={true}
                  className={'border bg-card ' + (!course.hasGps ? 'opacity-60' : '')}
                  onClick={() => course.hasGps ? onSelectCourse(course) : null}
                  disabled={!course.hasGps}
                >
                  <div className='space-y-2 py-2 w-full'>
                    <div className="font-semibold text-xl">{course.courseName}</div>
                    <div className="text-sm text-primary dark:text-green-200">
                      {course.holes} {t('holes')}
                    </div>
                    {!course.hasGps && (
                      <p className="text-xs text-amber-500 mt-1">{t('coming_soon')}</p>
                    )}
                  </div>
                </IonItem>
              ))
            ) : (
              <div className="text-center py-4 text-muted-foreground">
                {t('no_courses_found', 'No courses found for this club')}
              </div>
            )}
          </IonList>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CourseSelectionPage;
